export default "__VITE_ASSET__SmRwbfy$__"